import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { Alert, Fade } from '@mui/material';
import {
  WAuthLayout,
  WLoginForm,
  WTranslationProvider,
} from '@wareclouds/wareclouds-ui';

import logo from '../../assets/img/logo.svg';
import { useYupValidationTranslations } from '../common/hooks';
import { loginSchema, defaultValuesLoginForm } from './utils';
import { useLogin } from './services';
import { useState } from 'react';

export default function LoginPage() {
  const { t } = useTranslation(['auth']);

  const navigate = useNavigate();

  const translateError = useYupValidationTranslations();

  const { isPending, mutate: postLogin, isError, error } = useLogin();

  const [isValidationError, setIsValidationError] = useState(false);

  const onSubmit = (data) => {
    postLogin(data);
  };

  const errorHandler = (errors) => {
    setIsValidationError(!!errors?.username);
  };

  return (
    <WTranslationProvider t={t} translateError={translateError}>
      <WAuthLayout
        title={t('login.title', { ns: 'auth' })}
        logo={logo}
        termsAndConditionUrl="/terms"
        showTermsAndCondition
      >
        <WLoginForm
          submitHandler={onSubmit}
          onRecoveryClick={() => {
            navigate('/password-request', { state: { mode: 'forgot' } });
          }}
          hasUsernameHelperText
          isSubmitting={isPending}
          resolver={yupResolver(loginSchema)}
          defaultValues={defaultValuesLoginForm}
          onError={errorHandler}
        />
        <Fade in={isValidationError} timeout={300} mountOnEnter unmountOnExit>
          <Alert severity="warning" sx={{ mt: 2 }}>
            {t('form.invalid_username', { ns: 'auth' })}
          </Alert>
        </Fade>
        <Fade in={isError} timeout={300} mountOnEnter unmountOnExit>
          <Alert severity="error" sx={{ mt: 2 }}>
            {t(`system.${error?._customMessage}`, { ns: 'auth' })}
          </Alert>
        </Fade>
      </WAuthLayout>
    </WTranslationProvider>
  );
}
